import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Container = ({ className = "", children }) => (
  <div className={`mx-auto w-full max-w-[1200px] px-5 md:px-8 ${className}`}>{children}</div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-gold-500">{children}</span>
);

export const SectionHead = ({ eyebrow, title, sub, center = false, className = "" }) => (
  <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.05] tracking-tight text-white">{title}</h2>
    {sub && <p className="mt-4 text-base text-zinc-400 md:text-lg">{sub}</p>}
  </div>
);

const base = "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500/60";
const sizes = { md: "px-6 py-3 text-sm", lg: "px-7 py-3.5 text-base" };
const variants = {
  primary: "bg-gold-500 text-black hover:bg-gold-400 hover:shadow-[0_10px_30px_-8px_rgba(212,175,55,0.6)]",
  secondary: "border border-white/25 text-white hover:border-gold-500 hover:text-gold-400",
  ghost: "text-white hover:text-gold-400",
};

export const Button = ({ to, onClick, href, variant = "primary", size = "md", icon = true, className = "", children, ...rest }) => {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  const content = <>{children}{icon && <ArrowRight size={16} />}</>;
  if (to) return <Link to={to} className={cls} {...rest}>{content}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{content}</a>;
  return <button onClick={onClick} className={cls} {...rest}>{content}</button>;
};
